import { render, staticRenderFns } from "./VantActivityDayLuckPop.vue?vue&type=template&id=4bd03c52&"
import script from "./VantActivityDayLuckPop.vue?vue&type=script&lang=js&"
export * from "./VantActivityDayLuckPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports